import { PersonRoleType } from './shared.enums';

export interface PaginatedData<T> {
  data: T[];
  skipped: number;
  taken: number;
  rowCount: number;
  nextPage: string;
  previousPage: string;
}

export interface PaginatedDataRequest {
  skip?: number;
  take?: number;
}

export interface ComplexPaginatedDataRequest extends PaginatedDataRequest {
  sort?: Array<{ selector: string; desc: boolean }>;
  filter?: string;
}

export interface ProjectDataRequest extends ComplexPaginatedDataRequest {
  currency?: string[];
  country?: string[];
  category?: string[];
  interest?: string;
  yield?: string;
  duration?: string;
}

export interface BaseMasterDataRequest {
  code: string;
  description: string;
  isActive: boolean;
  isActiveAdmin: boolean;
  localized: { [language: string]: string };
}

export interface BaseMasterDataResponse {
  id: string;
  code: string;
  description: string;
  localized: { [language: string]: string };
}

export interface LocalizedValue extends BaseMasterDataResponse {
  isActive: boolean;
}

export interface BaseEnumResponse {
  id: number;
  name: string;
  description: string;
}

export interface FileResponse {
  id: string;
  blobId: string | null;
  name: string;
  description: string;
  fileType: number;
  fileName: string | null;
  originalFileName: string | null;
  extension: string | null;
  contentType: string | null;
  size: number;
}

export interface PersonAddress {
  countryCode: string | null;
  zipCode: string | null;
  city: string | null;
  publicSpace: string | null;
  publicSpaceType: string | null;
  houseNumber: string | null;
  doorOrFloor: string | null;
}

export interface BaseMasterDataSimplifiedResponse {
  id: string;
  code: string;
  description: string | null;
}

export interface NameData {
  connectionTypeCode: PersonRoleType | null;
  lastName: string;
  middleName: string | null;
  firstName: string;
}

export interface TitleNameData extends NameData {
  title: string | null;
}

export class LoadingState {
  constructor(
    public loading: boolean,
    public loaded: boolean,
    public error: string | null,
  ) {}
}

export const DEAFAULT_LOADING_STATE = new LoadingState(false, false, null);
export const ACTUALLY_LOADING_SATE = new LoadingState(true, false, null);
export const RELOADING_LOADING_STATE = new LoadingState(true, true, null);
export const LOADED_LOADING_STATE = new LoadingState(false, true, null);
